/**
 * Round 19 H55 -- the audit filter offered "Pick from 45 recorded types"
 * as raw codes (`admin.settings.app_setting.update`). An option reads as
 * words, who acted first ("Admin", "System"), then what and the verb;
 * the code stays the option's value and its hover, because the filter
 * matches on it.
 */
export function auditEventWords(code: string): string {
  const parts = code.split(".").filter(Boolean);
  if (parts.length === 0) return code;
  const words = parts.map((p) => p.replace(/_/g, " "));
  const [who, ...rest] = words;
  const head = who!.charAt(0).toUpperCase() + who!.slice(1);
  return rest.length > 0 ? `${head}: ${rest.join(" · ")}` : head;
}
